export default {
  mapRightClick: {
    'options': 'Opzioni',
    'addDestinationToRoute': 'Aggiungi come destinazione',
    'directionsFromHere': 'Direzioni da qui',
    'directionsToHere': 'Direzioni fino a qui',
    'nonStopDirectionsToHere': 'Navigazione diretta fino a qui',
    'addRouteStop': 'Aggiungi uno stop qui',
    'centerHere': 'Centra qui',
    'addAsIsochroneCenter': 'Aggiungi come centro dell\'isocrona',
    'inspectDataOnOSM': 'Visualizza i dati in OSM'
  }
}
